import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import Layout from "@/router/layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import EcSelect from "@/components/widgets/EcSelect.vue";
import { ClockWorkAnalyticsModule } from "@/store/modules/clockWorkAnalytics.module";
import { ClockWorkAnalyticsRequestModel } from "@/store/models/clockWorkAnalytics/clockWorkAnalyticsRequest";
import clockWorkAnalyticsMachine from "./machines/clockworkAnalyticsMachine";
import { interpret } from "xstate";
let ClockworkAnalytics = /** @class */ (() => {
    let ClockworkAnalytics = class ClockworkAnalytics extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.title = "Clockwork Analytics";
            this.items = [
                {
                    text: "Home",
                    to: "/dashBoard",
                },
                {
                    text: "Analytics",
                    href: "#",
                },
                {
                    text: "Clockwork Analytics",
                    active: true,
                },
            ];
            this.clockWorkAnalyticsRequest = new ClockWorkAnalyticsRequestModel();
            this.dateRange = null;
            this.selected = [];
            this.machine = clockWorkAnalyticsMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
        }
        send(event) {
            this.machineService.send(event);
        }
        Submit() {
            this.validate("validateObserver").then((response) => {
                if (response) {
                    this.SetDateForRequests();
                    this.selectedTeamId();
                    var formatedDatePeriod = this.GetDateFormatted();
                    this.machineService.send({ type: "GETTING_CLOCKWORK_ANALYTICS", clockWorkAnalyticsRequest: this.clockWorkAnalyticsRequest, formattedDate: formatedDatePeriod });
                }
            });
        }
        GenerateExcelReport() {
            this.machineService.send({ type: "EXPORT_CLOCKWORK_ANALYTICS", clockWorkAnalyticsRequest: this.clockWorkAnalyticsRequest });
        }
        GetDateFormatted() {
            var startDate = this.dateFormattedStringDDMMMYYYY(this.dateRange[0]);
            var endDate = this.dateFormattedStringDDMMMYYYY(this.dateRange[1]);
            return `${startDate} - ${endDate}`;
        }
        Clear() {
            this.selected = [];
            this.dateRange = null;
            ClockWorkAnalyticsModule.ClearClockWorkAnalytics();
            this.machineService.send({ type: "CANCEL" });
        }
        clearSelectedDate() {
            this.dateRange = null;
        }
        selectionChanged(selectedObjects) {
            if (selectedObjects.id == this.emptyGuid) {
                this.selected = [];
                this.selected.push(selectedObjects);
            }
            else {
                this.selected = this.selected.filter((x) => x.id != this.emptyGuid);
                this.selected.push(selectedObjects);
            }
        }
        selectedTeamId() {
            this.clockWorkAnalyticsRequest.teamId = this.selected.map((item) => item.id);
        }
        SetDateForRequests() {
            this.clockWorkAnalyticsRequest.startDate = this.dateRange[0];
            this.clockWorkAnalyticsRequest.startDateAsString = this.dateFormattedString(this.dateRange[0]);
            this.clockWorkAnalyticsRequest.endDate = this.dateRange[1];
            this.clockWorkAnalyticsRequest.endDateAsString = this.dateFormattedString(this.dateRange[1]);
        }
        get teams() {
            return ClockWorkAnalyticsModule.defaults;
        }
        get clockWorkAnalytics() {
            return ClockWorkAnalyticsModule.clockWorkAnalytics;
        }
        created() {
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
            });
        }
        destroyed() {
            this.Clear();
            this.machineService.stop();
        }
    };
    ClockworkAnalytics = __decorate([
        Component({
            name: "ClockworkAnalytics",
            components: {
                Layout,
                PageHeader,
                Loader,
                simplebar,
                EcSelect,
                SectionLoader,
            },
        })
    ], ClockworkAnalytics);
    return ClockworkAnalytics;
})();
export default ClockworkAnalytics;
